<template>
  <div class="main">
	  <div class="loading">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
export default {
  created () {
    const {code,type}=this.$route.query;
    this.$httpList.loginWithSso(type,code).then(res=>{
      if(res.resultCode=='1001'){
        let token = res.data?.access_token; 
        if (token) {
          this.$actions.setGlobalState({
            accessToken: token,
          });
          localStorage.setItem(
            "accessToken",
            token
          );
          this.$router.push({
            name: "Home",
          });
        }else{
          Notification.error(this.$t("loginPromptMessage.loginError"));
          this.$router.push({ name: "Login" });
        }
      }
    })
  },
}
</script>

<style lang="scss" scoped>
.main{
		width: 100%;
		height: 100vh;
    display:flex;
    align-items: center;
    justify-content: center;
	}
	a{
		display: block;
		text-align: center;
		font-size: 20px;
		margin-top: 200px;
	}
	.loading{
		width: 150px;
		height: 15px;
	}
	.loading span{
		display: inline-block;
		width: 15px;
		height: 100%;
		margin-right: 5px;
		border-radius: 50%;
		background: $primary;
		-webkit-animation: load 1.5s ease infinite;
	}
	.loading span:last-child{
		margin-right: 0px; 
	}
	@-webkit-keyframes load{
		0%{
			opacity: 1;
		}
		100%{
			opacity: 0;
		}
	}
	.loading span:nth-child(1){
		-webkit-animation-delay:0.13s;
	}
	.loading span:nth-child(2){
		-webkit-animation-delay:0.26s;
	}
	.loading span:nth-child(3){
		-webkit-animation-delay:0.39s;
	}
	.loading span:nth-child(4){
		-webkit-animation-delay:0.52s;
	}
	.loading span:nth-child(5){
		-webkit-animation-delay:0.65s;
	}
</style>